/**
 * Custom product card swatches component used
 * to render color swatches on product cards.
 */
class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.sectionId = this.dataset.sectionId;
    this.swatchButtons = this.querySelectorAll('button.card-swatch-button');
    this.variantImages = this.closest('.card-swatches-wrapper').querySelector('.card__variant-images');
    this.mainImage = this.closest('.card-swatches-wrapper').querySelector('.card__media img');
    this.productCard = this.closest('.card-swatches-wrapper');
    this.quickAddButton = this.productCard.querySelector('quick-add-button');
    this.productLinks = this.productCard.querySelectorAll('.custom-product-link');

    this.bindEvents();
  }

  bindEvents() {
    this.swatchButtons.forEach(button => {
      button.addEventListener('click', this.handleSwatchClick.bind(this));
    });
  }

  handleSwatchClick(event) {
    const button = event.currentTarget;
    const mediaId = button.dataset.mediaId;
    
    // Update active state
    this.swatchButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Update image
    this.updateProductImage(mediaId);

    // Update quick add button if it exists
    if (this.quickAddButton) {
      const variantValue = button.dataset.value;
      this.updateQuickAdd(variantValue);
    }

    // Update product URLs
    this.updateProductUrls(button.dataset.variantId);
  }

  updateProductImage(mediaId) {
    if (!mediaId) return;

    const newImage = this.variantImages.querySelector(`[data-media-id="${mediaId}"]`);
    if (!newImage) return;

    const clonedImage = newImage.cloneNode(true);
    this.mainImage.parentElement.replaceChild(clonedImage, this.mainImage);
    this.mainImage = clonedImage;
  }

  updateQuickAdd(variantValue) {
    if (!this.quickAddButton) return;

    // Update the quick add button's variant selection
    const variantSelect = this.quickAddButton.querySelector('select');
    if (variantSelect) {
      for (let i = 0; i < variantSelect.options.length; i++) {
        const option = variantSelect.options[i];
        if (option.text.includes(variantValue)) {
          variantSelect.selectedIndex = i;
          variantSelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    }
  }

  updateProductUrls(variantValue) {
    if (!this.productLinks || !variantValue) return;

    this.productLinks.forEach(link => {
      const currentUrl = new URL(link.href);
      currentUrl.searchParams.set('variant', variantValue);
      link.href = currentUrl.toString();
    });
  }
}

customElements.define('card-swatches', ProductCardSwatches);
